import * as React from "react";
import {
  DataGrid,
  gridPaginationModelSelector,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid";
import "../Styles/CTRtable.module.css";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { actionsOptions, ls } from "../../../../variables";
import axios from "axios";
import { useStateValue } from "../../../../Hooks/stateProvider";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import CloseIcon from "@mui/icons-material/Close";
import {
  Button,
  Card,
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  ListItemText,
  MenuItem,
  Select,
  TablePagination,
  TextField
} from "@mui/material";
import { encrypt } from "../../../../utils/cipher";
import CommentDialogBox from "../../../CommonLayouts/CommentDialogBox";
import UploadAction from "../../../CommonLayouts/UploadAction";
import uploadLogo from "../../../../images/CtrUpload.svg";
import Swal from "sweetalert2";
import ViewHistory from "../../../../components/ViewHistory";
import { LightTooltip } from "../../../../components/LightTooltip";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { VisuallyHiddenInput } from "../../../../components/VisuallyHiddenInput";
import { errorHandler } from "../../../../utils/errorHandling";
import { alert } from "../../../../utils/sweetAlert";
import CustomNoRowsOverlay from "../../../../components/CustomNoRowsOverlay";
import Loader from "../../../../Loader/Loader";

export default function TrackerTable({ type, fy_year, quarter, previewFunc, rows, setRows, openNestedList, renderType, setApiStatus, setBriefData,
  trackerPageFetch,
  pmsName,
  setFilteredRows,
  cacheData,
  setCacheData, submitMessage, submitStatus }) {    
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const [openModal, setOpenModal] = React.useState(false);
  const [openHistoryModal, setOpenHistoryModal] = React.useState(false);
  const [ctrHytrIds, setCtrHytrIds] = React.useState([]);
  const [{ moduleType, fileName, fileDetails, pageLoading }, dispatch] = useStateValue();
  const userType = ls.get("userType");
  const [takeAction, setTakeAction] = useState(false);
  const [rowsChanged, setRowChanged] = useState({});
  const [message, setMessage] = useState("");

  const handleDownload = async () => {
    let payload;
    if (moduleType == "CMM") {
      payload = {
        moduleType: moduleType,
        selectedFilters: openNestedList,
        fy_year: fy_year,
        pmsName: pmsName,
        quarter: quarter,
        authToken: ls.get("authToken"),
        refreshToken: ls.get("refreshToken"),
      };
    }


    let encryptedPayload = await encrypt(payload);

    dispatch({ type: "SHOW_LOADER" });
    axios
      .post("/api/pms/downloadAlerts", { payload: encryptedPayload })
      .then((res) => {
        // console.log("RES", res);
        dispatch({ type: "HIDE_LOADER" });
        setOpenModal(false)
        window.open(res.data.data, "_self");
      })
      .catch((err) => {
        dispatch({ type: "HIDE_LOADER" });
        setOpenModal(false)
        errorHandler(err, navigate);
      });
  };

  const handleFileDownload = async (uploadS3FilePath) => {
    try {
      if (uploadS3FilePath == undefined || uploadS3FilePath == "") {
        alert("Sorry!!", "No File Found!", "error")
        return;
      }
      //   uploadS3FilePath = await decrypt(uploadS3FilePath);
      const downloadPayload = {
        s3Location: uploadS3FilePath,
        moduleType: moduleType.toUpperCase(),
        authToken: ls.get("authToken"),
        refreshToken: ls.get("refreshToken")
      };
      dispatch({ type: "SHOW_LOADER" });
      let encryptedPayload = await encrypt(downloadPayload)
      const result = axios.post("/api/pms/downloadReport", { payload: encryptedPayload });
      result.then((response) => {
        dispatch({ type: "HIDE_LOADER" });
        if (response.data.success) {
          window.open(response.data.data, "_self");
        }
      });
    }
    catch (err) {
      dispatch({ type: "HIDE_LOADER" });
      errorHandler(err, navigate);
    }

  };

  useEffect(() => {
    if (openNestedList?.localStatusData?.includes('open (pms)') || openNestedList?.localStatusData?.length == 0) {
      setMessage("Please select open (sebi) status only to proceed.");
      setTakeAction(true);
    }
    else {
      setMessage("");
      setTakeAction(false);
    }
  }, [openNestedList])

  const handleSubmit = async () => {

    let headers;
    if (moduleType == "CMM") {
      headers = {
        moduletype: moduleType,
        fy_year: fy_year,
        pmsName: pmsName,
        // quarter: quarter,
        authtoken: ls.get("authToken"),
        refreshtoken: ls.get("refreshToken")
      }
    }

    const encryptedHeaders = await encrypt(headers)

    const formData = new FormData();
    formData.append("files", fileDetails);
    formData.append("fileName", fileName);

    dispatch({ type: "SHOW_LOADER" });

    axios.post("/api/pms/uploadAlerts", formData, {
      headers: {
        headers: encryptedHeaders
      }
    })
      .then((res) => {
        dispatch({ type: "HIDE_LOADER" });
        setCacheData(true);
        setFilteredRows(res.data.finalResult.map((val) => ({ ...val, id: val.cmm_id })))
        setOpenModal(false)
      })
      .catch((err) => {
        console.log("err value", err);
        dispatch({ type: "HIDE_LOADER" });
        setOpenModal(false)
        errorHandler(err, navigate);
      });
  }
 

  const handleTableDrop = async () => {
    let payload;
    Swal.fire({
      icon: "warning",
      title: "Are you sure, you want to reset?",
      showCancelButton: true,
      confirmButtonColor: "#154063",
      cancelButtonColor: "#d33",
      cancelButtonText: "No",
      confirmButtonText: "Yes",
    }).then(async (val) => {
      if (val.isConfirmed) {
        if (moduleType == "CMM") {
          payload = {
            moduleType: moduleType,
            fy_year: fy_year,
            pmsName: pmsName,
            quarter: quarter,
            authToken: ls.get("authToken"),
            refreshToken: ls.get("refreshToken"),
          };
        }
       

        let encryptedPayload = await encrypt(payload);

        dispatch({ type: "SHOW_LOADER" });
        axios
          .post("/api/pms/dropAlerts", { payload: encryptedPayload })
          .then((res) => {
            dispatch({ type: "HIDE_LOADER" });
            if (res.data.success) {
              alert("Success", "Your table was successfully reset", "success")
              trackerPageFetch();
            }
          })
          .catch((err) => {
            setOpenModal(false)
            dispatch({ type: "HIDE_LOADER" });
            errorHandler(err, navigate)
          });
      }

    })

  }

  const handleSave = async () => {
    let payload;
    if (type === "cmm") {
      payload = {
        pmsName: pmsName,
        fy_year: fy_year,
        quarter: quarter,
        fileType: "CMM",
        requiredDocuments: Object.values(rowsChanged),
        authToken: ls.get("authToken"),
        refreshToken: ls.get("refreshToken"),
        flag: "tracker"
      };
    }
    dispatch({ type: "SHOW_LOADER" });
    const encryptedPayload = await encrypt(payload);
    axios
      .post(
        "api/pms/saveDocument",
        { payload: encryptedPayload }
      )
      .then(async (response) => {
        dispatch({ type: "HIDE_LOADER" });
        if (response.data.success) {
          alert("Data saved", "Data has been saved successfully", "success")
          setRowChanged({});
          trackerPageFetch();
        } else {
          alert("Oops...", "Something went wrong!", "error")
        }
      })
      .catch((err) => {
        console.log("error:", err);
        dispatch({ type: "HIDE_LOADER" });
        errorHandler(err, navigate)

      });
  };

  const handleFileDelete = async (id) => {
    try {
      const payload = {
        id: id,
        moduleType: moduleType,
        flag: "tracker",
        authToken: ls.get("authToken"),
        refreshToken: ls.get("refreshToken")
      };
      let encryptedPayload = await encrypt(payload)
      dispatch({ type: "SHOW_LOADER" });
      const result = axios.post("/api/pms/deleteDocument", { payload: encryptedPayload });
      result.then((response) => {
        dispatch({ type: "HIDE_LOADER" });
        if (response.data.success) {
          trackerPageFetch();
        }
      });
    }
    catch (err) {
      dispatch({ type: "HIDE_LOADER" });
      errorHandler(err, navigate)
    }
  }

  const handleTrackerSubmit = async () => {
    let payload;
    Swal.fire({
      icon: "warning",
      title: "Are you sure, you want to submit?",
      html: `<span style="font-weight: bold;">Please save before final submission</span>`,
      showCancelButton: true,
      confirmButtonColor: "#154063",
      cancelButtonColor: "#d33",
      cancelButtonText: "No",
      confirmButtonText: "Yes",
    }).then(async (val) => {
      if (val.isConfirmed) {
        if (moduleType == "CMM") {
          payload = {
            moduleType: moduleType,
            fy_year: fy_year,
            pmsName: pmsName,
            quarter: quarter,
            authToken: ls.get("authToken"),
            refreshToken: ls.get("refreshToken"),
          };
        }

        let encryptedPayload = await encrypt(payload);

        dispatch({ type: "SHOW_LOADER" });
        axios
          .post("/api/pms/alertsSubmission", { payload: encryptedPayload })
          .then((res) => {
            if (res.data.success) {
              dispatch({ type: "HIDE_LOADER" });
              alert("Thank you!", "You request was successfully submitted", "success")
              trackerPageFetch();
            } else {
              dispatch({ type: "HIDE_LOADER" });
              alert("Oops...", "Something went wrong!", "error")
            }
          })
          .catch((err) => {
            dispatch({ type: "HIDE_LOADER" });
            errorHandler(err, navigate)
          });
      }

    })
  }


  const handleChangeGrid = (id, type = "selectAll", val) => {
    console.log("id, type & val", id, type, val)
    
    const objIndex = rows?.findIndex(
      (obj) => obj?.id === id
    );
    // console.log("objIndex value", objIndex)
    console.log("rows value", rows)
    if (type == "comment") {
      if (objIndex !== -1) {
        const updatedRows = [...rows];
        updatedRows[objIndex] = {
          ...updatedRows[objIndex],
          sebi_comments: val,
        };
        setFilteredRows(updatedRows);
        setRowChanged({
          ...rowsChanged,
          [updatedRows[objIndex]?.id]: updatedRows[objIndex],
        });
      }
    }
    else if (type == "selectAll") {
      if (objIndex !== -1) {
        const updatedRows = [...rows];
        let selectedValue;
        console.log("updatedRows value2", updatedRows[objIndex]?.action?.length)
        if ((updatedRows[objIndex]?.action?.length === actionsOptions?.length - 1) && !updatedRows[objIndex]?.action?.includes("Seek Explaination")) {
          selectedValue = [];
        }
        else {
          selectedValue = actionsOptions?.filter(val => val?.value != "Seek Explaination")?.map(val => val.value);
        }
        console.log("selectedValue",selectedValue)
        updatedRows[objIndex] = {
          ...updatedRows[objIndex],
          action: selectedValue,
        };
        setFilteredRows(updatedRows);
        setRowChanged({
          ...rowsChanged,
          [updatedRows[objIndex].id]: updatedRows[objIndex],
        });
      }
    }
    else {
      if (objIndex !== -1) {
        const updatedRows = [...rows];
        console.log("updatedRows value objIndex", objIndex)
        let selectedValue;
        const isSeekExplanationSelected = val === 'Seek Explaination';
        console.log("updatedRows value1", updatedRows[objIndex])
        if (updatedRows[objIndex]?.action?.includes('Seek Explaination')) {
          if (isSeekExplanationSelected) {
            selectedValue = [];
          } else {
            selectedValue = [val];
          }
        } else {
          if (isSeekExplanationSelected) {
            selectedValue = ['Seek Explaination'];
          } else {
            if (updatedRows[objIndex]?.action?.includes(val)) {
              selectedValue = updatedRows[objIndex]?.action?.filter(selectedId => selectedId !== val);
            } else {
              selectedValue = [...updatedRows[objIndex]?.action, val];
            }
          }
        }
        updatedRows[objIndex] = {
          ...updatedRows[objIndex],
          action: selectedValue,
        };
        setFilteredRows(updatedRows);
        setRowChanged({
          ...rowsChanged,
          [updatedRows[objIndex].id]: updatedRows[objIndex],
        });
      }
    }
  }
  const CustomFooter = ({ onSendClick }) => {
    const apiRef = useGridApiContext();
    const paginationModel = useGridSelector(
      apiRef,
      gridPaginationModelSelector
    );

    return (
      <Grid
        container
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "52px",
        }}
      >
        <Grid item xs={3}></Grid>
        <Grid item xs={6} sx={{ textAlign: "center" }}>
          {renderType != "initial" ? !cacheData ?
            <>
              <LightTooltip title={submitStatus ? `${submitMessage}` : takeAction ? `${message}` : rows.length == 0 ? "No rows available to take action." : ""} placement="top">
                <span>
                  <button
                    style={{
                      color: "#ffffff",
                      marginLeft: "10px",
                      height: "1.875rem",
                      width: "8.125rem",
                      backgroundColor: (submitStatus || takeAction || rows.length == 0 || ctrHytrIds.length == 0) ? "#808080" : "#154063",
                      cursor: (submitStatus || takeAction || rows.length == 0 || ctrHytrIds.length == 0) ? "default" : "pointer",
                      border: (submitStatus || takeAction || rows.length == 0 || ctrHytrIds.length == 0) ? "0.125rem solid #808080" : "0.125rem solid #154063",
                    }}
                    onClick={() => {
                      setOpen(true);
                      dispatch({
                        type: "SEBITrackerPageData",
                        SEBITrackerPageData: {
                          fy_year: fy_year,
                          quarter: quarter,
                          id: ctrHytrIds,
                        },
                      });
                    }}
                    disabled={submitStatus || takeAction || rows.length == 0 || ctrHytrIds.length == 0}
                  >
                    Take Action
                  </button>
                </span>
              </LightTooltip>
              {<LightTooltip title={submitStatus ? `${submitMessage}` : ""} placement="top">
                <span>
                  <button
                    style={{
                      color: "#ffffff",
                      marginLeft: "10px",
                      height: "1.875rem",
                      width: "fit-content",
                      backgroundColor: (submitStatus || rows.length == 0) ? "#808080" : "#154063",
                      cursor: (submitStatus || rows.length == 0) ? "default" : "pointer",
                      border: (submitStatus || rows.length == 0) ? "0.125rem solid #808080" : "0.125rem solid #154063"
                    }}
                    onClick={() => setOpenModal(true)}
                    disabled={submitStatus || rows.length == 0}
                  >
                    Take Action Using Excel
                  </button>
                </span>
              </LightTooltip>}
            </>
            :
            <div style={{ display: "flex", justifyContent: "center", gap: "1rem" }}>
              <button style={{
                color: "#ffffff",
                height: "1.875rem",
                width: "8.125rem",
                backgroundColor: "#154063",
                borderColor: "#154063",
                cursor: "pointer",
              }}
                onClick={handleSave}>SAVE</button>
              <button
                style={{
                  color: "#ffffff",
                  fontSize: "0.8rem !important",
                  backgroundColor: "#ff6666",
                  border: "0.125rem solid #ff6666",
                  borderRadius: "0.125rem",
                  width: "8.125rem",
                  cursor: "pointer",
                  height: "1.875rem",
                  width: "8.125rem",
                }}
                onClick={handleTableDrop}
              >
                DROP
              </button>
              <button
                style={{
                  color: "#ffffff",
                  height: "1.875rem",
                  width: "8.125rem",
                  backgroundColor: "#154063",
                  borderColor: "#154063",
                  cursor: "pointer",
                }}
                onClick={handleTrackerSubmit}
              >
                SUBMIT
              </button>
            </div> : <div></div>}
        </Grid>
        <Grid item xs={3}>
          <TablePagination
            component="div"
            className="table_pagination"
            count={rows.length}
            page={paginationModel.page}
            onPageChange={(event, value) => apiRef.current.setPage(value)}
            rowsPerPage={paginationModel.pageSize}
            rowsPerPageOptions={[]}
          />
        </Grid>
      </Grid>
    );
  };
  const initialCtrColumns = [
    {
      field: "pmsName",
      headerName: "PMS  Name",
      minWidth: 110,
      flex: 0.5,
      align: "center",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "total_clauses",
      headerName: "Total Clauses",
      minWidth: 120,
      flex: 0.5,
      align: "center",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "open_clauses",
      headerName: "Open Clauses",
      minWidth: 130,
      flex: 0.5,
      align: "center",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "initial_response_received",
      headerName: "Initial Response Received",
      minWidth: 250,
      flex: 0.5,
      align: "center",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false
    },
    {
      field: "clarification_sought",
      headerName: "Clarification Sought",
      minWidth: 170,
      flex: 0.5,
      align: "center",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false
    },
    {
      field: "final_closure_pending",
      headerName: "Final Closure Pending",
      minWidth: 200,
      flex: 0.5,
      align: "center",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "submission_date",
      headerName: "Submission Date",
      minWidth: 150,
      flex: 0.5,
      align: "center",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
    }
  ];
  
 
  const briefCtrColumns = !cacheData ? [
    {
      field: "index",
      headerName: "S.No",
      minWidth: 40,
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "unreadAlert",
      headerName: "",
      minWidth: 30,
      maxWidth: 40,
      flex: 1,
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
      cellClassName: "no-border-left",
      renderCell: (params) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {params.row.status == "open (sebi)" && <PriorityHighIcon />}
          </div>
        );
      },
    },
    {
      field: "particulars",
      headerName: "Particulars",
      minWidth: 200,
      flex: 1.5,
      align: "left",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
      renderCell: (params) => {
        return (
          <LightTooltip sx={{ maxHeight: "40%", overflow: "auto" }} title={params.row.particulars} placement="right">
            <div style={{ cursor: "pointer" }}>{params.row.particulars}</div>
          </LightTooltip>
        );
      },
    },
    {
      field: "compliance_status",
      headerName: "Compliance Status",
      minWidth: 170,
      flex: 0.5,
      align: "center",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
      renderCell: (params) => {
        return (
          <LightTooltip title={params.row.compliance_percentage} placement="right">
            <div style={{ cursor: "pointer" }}>{params.row.compliance_status}</div>
          </LightTooltip>
        );
      },
    },
    {
      field: "view",
      headerName: "Correspondance",
      minWidth: 200,
      flex: 0.5,
      align: "center",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
      renderCell: (params) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              textDecoration: "underline",
              cursor: "pointer"
            }}
            onClick={() => {
              ls.set("type", "cmm");
              dispatch({
                type: "SEBITrackerPageData",
                SEBITrackerPageData: {
                  fy_year: fy_year,
                  quarter: quarter,
                  id: params.id,
                  particulars: params.row.particulars,
                  particulars: params.row.particulars
                },
              });
              setOpenHistoryModal(true);
            }}
          >
            View History
          </div>
        );
      },
    },
  ] : [
    {
      field: "unreadAlert",
      headerName: "",
      minWidth: 30,
      maxWidth: 40,
      flex: 1,
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
      cellClassName: "no-border-left",
      renderCell: (params) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {params.row.status == "open (sebi)" && <PriorityHighIcon />}
          </div>
        );
      },
    },
    {
      field: "particulars",
      headerName: "Particulars",
      minWidth: 200,
      flex: 1.5,
      align: "left",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
      renderCell: (params) => {
        return (
          <LightTooltip sx={{ maxHeight: "40%", overflow: "auto" }} title={params.row.particulars} placement="right">
            <div style={{ cursor: "pointer" }}>{params.row.particulars}</div>
          </LightTooltip>
        );
      },
    },
    {
      field: "compliance_status",
      headerName: "Compliance Status",
      minWidth: 170,
      flex: 0.5,
      align: "center",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
      renderCell: (params) => {
        return (
          <LightTooltip title={params.row.compliance_percentage} placement="right">
            <div style={{ cursor: "pointer" }}>{params.row.compliance_status}</div>
          </LightTooltip>
        );
      },
    },
    {
      field: "view",
      headerName: "Correspondance",
      minWidth: 200,
      flex: 0.5,
      align: "center",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
      renderCell: (params) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              textDecoration: "underline",
              cursor: "pointer"
            }}
            onClick={() => {
              ls.set("type", "cmm");
              dispatch({
                type: "SEBITrackerPageData",
                SEBITrackerPageData: {
                  fy_year: fy_year,
                  quarter: quarter,
                  id: params.id,
                  particulars: params.row.particulars,
                },
              });
              setOpenHistoryModal(true);
            }}
          >
            View History
          </div>
        );
      },
    },
    {
      field: "sebi_comments",
      headerName: "SEBI Comments",
      minWidth: 200,
      flex: 0.5,
      align: "center",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
      renderCell: (params) => {
        return <>
          <TextField
            id="outlined-textarea"
            defaultValue={params.row?.sebi_comments}
            // disabled={true}
            style={{ width: "100%" }}
            onKeyDown={(event) => {
              event.stopPropagation();
            }}
            onChange={(e) => handleChangeGrid(params.row.id, "comment", e.target.value)}
            placeholder="Enter Comment"
            multiline
          />
        </>
      },
    },
    {
      field: "action",
      headerName: "Action Type",
      minWidth: 200,
      flex: 0.5,
      align: "center",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
      renderCell: (params) => {
        return <Select
          value={params.row?.action || []}
          MenuProps={{
            PaperProps: {
              sx: {
                color: "#000000",
                "& .MuiMenuItem-root": {
                  padding: 1,
                },
                height: "20%",
              },
            },
          }}
          sx={{
            backgroundColor: "#EAEAEA",
            width: "100%",
            // height: "100%",
          }}
          displayEmpty
          renderValue={(selected) => {
            if (selected.length === 0) {
              return "Select Remarks";
            }
            return selected.join(", ");
          }
          }
          multiple
        >
          <MenuItem style={{ display: "flex", justifyContent: "center", alignItems: "center" }} onClick={() => handleChangeGrid(params.row.id)}>
            <Checkbox
              checked={params.row?.action?.length === actionsOptions.length}
              indeterminate={params.row?.action?.length > 0 && params.row?.action?.length < actionsOptions.length}
            />
            <ListItemText primary="Any action taken" />
          </MenuItem>
          
          {actionsOptions.map((name) => (
            <MenuItem key={name.label} value={name.value} onClick={() => handleChangeGrid(params.row.id, "select", name.label)}>
              <Checkbox
                checked={params.row?.action?.includes(name.value)}
              />
              <ListItemText primary={name.label} />
            </MenuItem>
          ))}
          <MenuItem key={'Seek Explaination'} value={'Seek Explaination'} onClick={() => handleChangeGrid(params.row.id, "select", 'Seek Explaination')}>
            <Checkbox
              checked={params.row?.action?.includes('Seek Explaination')}
            />
            <ListItemText primary={'Seek Explaination'} />
          </MenuItem>
        </Select>;
      },
    },
    {
      field: "uploadUtil",
      headerName: "Attachments",
      minWidth: 150,
      flex: 0.5,
      align: "center",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
      renderCell: (params) => {
        return <>
          {(params.row.filename == null || params.row.filename == '' || params.row.filename == undefined) ?
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Button
                sx={{
                  backgroundColor: "#154063",
                  "&:hover": { backgroundColor: "#154063" },
                }}
                className="UploadFileButton"
                component="label"
                variant="contained"
              >
                UPLOAD
                <VisuallyHiddenInput
                  type="file"
                  onChange={(event) => {
                    handleFileUpload(params.row, event?.target?.files[0], event?.target?.files[0]?.name)
                  }}
                />
              </Button>
            </div> :
            <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
              <h3 style={{ cursor: "pointer" }} onClick={() => handleFileDownload(params.row.s3_location)}>{params.row.filename}</h3>
              <DeleteForeverIcon sx={{ color: "#e6435b", cursor: "pointer" }} onClick={() => {
                handleFileDelete(params.row[`${moduleType.toLowerCase()}_id`])
              }} />
            </div>
          }
        </>;
      },
    },
  ];
 


  let columns;
  if (renderType == 'initial') {
    type == "cmm" ? (columns = initialCtrColumns) : (columns = "");
  } else {
    type == "cmm" ? (columns = briefCtrColumns) : (columns = "");
  }

  const handleRowClick = (params) => {
    if (params.row.pmsName && renderType == "initial") {
      setApiStatus('brief');
      setBriefData(params.row);
    }
  }

  const handleFileUpload = async (params, file, fileName) => {

    const formData = new FormData();
    formData.append("file", file);
    formData.append("fileName", fileName);

    let headers;
    if (moduleType == "CMM") {
      headers = {
        filetype: "CMM",
        fy_year: params.fy_year,
        quarter: params.quarter,
        pmsName: pmsName,
        sebi_comments: params.sebi_comments,
        action: params?.action,
        flag: "tracker",
        cmm_id: params.cmm_id,
        authtoken: ls.get("authToken"),
        refreshtoken: ls.get("refreshToken")
      }
    }
    

    const encryptedHeaders = await encrypt(headers)

    dispatch({ type: "SHOW_LOADER" });
    axios
      .post("api/pms/supportDocumentUpload", formData, {
        headers: {
          headers: encryptedHeaders
        }
      })
      .then((response) => {
        if (response.data.success) {
          dispatch({ type: "HIDE_LOADER" });
          alert("Uploaded", "File uploaded successfully", "success")
          setFilteredRows(rows.map((row) =>
            (row.id ?? row.cmm_id) === (params.id ?? params.cmm_id)
              ? { ...row, filename: fileName }
              : row
          ));
        }
        else {
          dispatch({ type: "HIDE_LOADER" });
          alert("Oops...", "Something went wrong!", "error")
        }
      })
      .catch((err) => {
        dispatch({ type: "HIDE_LOADER" });
        console.error("Error uploading file:", err);
        errorHandler(err, navigate);
      })
  }
  return (
    <>
      <div style={{ height: "100%", width: "100%", marginTop: "0%" }}>
        <Loader />
        <DataGrid
          getRowId={(row) => row.id ?? row.cmm_id}
          getRowHeight={() => "auto"}
          rows={rows}
          columns={columns}
          rowSelectionModel={ctrHytrIds}
          onRowSelectionModelChange={(selectedRowsID) => {
            const filteredSelection = selectedRowsID.filter((id) => {
              const selectedRow = rows.find((row) => row.id == id);
              return selectedRow.status === "open (sebi)" || "closed";
            });
            setCtrHytrIds(filteredSelection);
            // console.log("ctrIds", ctrHytrIds);
          }}
          sortModel={[
            {
              field: 'index',
              sort: 'asc', // 'asc' for ascending, 'desc' for descending
            },
          ]}
          sx={{
            width: "fit-content",
            "& .MuiDataGrid-columnHeaderTitleContainer": {
              justifyContent: "center",
              backgroundColor: "#154063",
              fontSize: "1rem",
            },
            "& .MuiDataGrid-withBorderColor": {
              borderRight: "none",
            },
            "& .MuiDataGrid-columnSeparator--sideRight": { display: "none" },
            "& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
              display: "none",
            },
            "& .MuiDataGrid-columnHeaders": { width: "fit-content" },
            "& .MuiDataGrid-topContainer": { width: "fit-content" },
            "& .MuiDataGrid-cell": {
              whiteSpace: "normal",
              wordWrap: "break-word",
              overflowX: "hidden",
            },
            "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
              py: "5px",
            },
            "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
              py: "8px",
            },
            "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
              py: "15px",
            },
            "& .MuiDataGrid-overlayWrapper": {
              position: "static"
            }
          }}
          style={{
            color: "#154063",
            width: "100%",
            whiteSpace: "nowrap",
            height: "100%",
            borderWidth: "2px",
            borderRadius: "10px",
            overflowX: "hidden",
          }}
          slots={{
            noRowsOverlay: CustomNoRowsOverlay,
            footer: CustomFooter,
          }}
          footer={{
            render: (params) => <CustomFooter />,
          }}
          checkboxSelection={!cacheData && renderType != 'initial' ? true : false}
          rowsPerPageOptions={[2, 5, 10]}
          AutoGenerateColumns={false}
          disableRowSelectionOnClick
          disableColumnMenu
          disableRowCount
          disableColumnSelector
          scrollbarSize={0}
          onRowClick={handleRowClick}
          autoPageSize
        />
      </div>
      {open && (
        <CommentDialogBox
          userType={userType}
          open={open}
          setOpen={setOpen}
          // fetchData={viewPageFetch}
          onClose={() => setOpen(false)}
          trackerPageFetch={trackerPageFetch}
        // selectedInstID={selectedInstID}
        />
      )}
      <Dialog
        fullWidth
        maxWidth="sm"
        open={openModal}
        onClose={() => setOpenModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      // PaperProps={{
      //   sx: {
      //     height: "65%",
      //   },
      // }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <div className="closeIcon" onClick={() => setOpenModal(false)}>
            <CloseIcon
              sx={{ cursor: "pointer", "&:hover": { color: "#ff0000" } }}
            />
          </div>
        </DialogTitle>
        <DialogContent
          sx={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            gap: "1rem",
          }}
        >
          <div>
            <button
              style={{
                color: "#ffffff",
                height: "1.875rem",
                width: "8.125rem",
                backgroundColor: "#154063",
                borderColor: "#154063",
                cursor: "pointer",
              }}
              onClick={() => handleDownload()}
            >
              Download Report
            </button>
          </div>
          <div style={{ width: "100%" }}>
            <Card
              sx={{
                boxShadow: "#808080",
                background: "#EFEFF4",
                justifyContent: "space-evenly",
                display: "flex",
                flexDirection: "column",
                borderRadius: "10px",
              }}
            >
              <div
                style={{
                  margin: "1rem",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  gap: "1rem",
                }}
              >
                <div>
                  <img src={uploadLogo} alt="Upload Logo" />
                  <p style={{ color: "#154063" }}>Choose a File</p>
                </div>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "1rem", flexDirection: "row" }}>
                  <div>
                    <UploadAction />
                  </div>
                  <div>
                    <button
                      style={{
                        color: "#ffffff",
                        height: "1.875rem",
                        width: "8.125rem",
                        backgroundColor: "#154063",
                        borderColor: "#154063",
                        cursor: "pointer",
                      }}
                      onClick={() => handleSubmit()}
                    >
                      SUBMIT
                    </button>
                  </div>
                </div>
              </div>
            </Card>
          </div>
        </DialogContent>
      </Dialog>
      {openHistoryModal && <ViewHistory openModal={openHistoryModal} setOpenModal={setOpenHistoryModal} />}
    </>);
}
